import antdData from 'antd/lib/locale-provider/en_US'
import localeData from 'react-intl/locale-data/en'

const messages = {
  'topBar.typeToSearch': 'Search...',
  'topBar.profileMenu.hello': 'Hello',
  'topBar.profileMenu.role': 'Role',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Phone',
  'topBar.profileMenu.gotoProfile': 'Go to Profile',
  'topBar.profileMenu.editProfile': 'Edit Profile',
  'topBar.profileMenu.changePassword': 'Change Password',
  'topBar.profileMenu.logout': 'Logout',
  'member.profile.emailAddressTitle': 'Email Address',
  'member.profile.emailAddress': 'Enter email address',
  'member.profile.validEmail': 'The input is not valid E-mail!',
  'member.profile.enterEmail': 'Please input E-mail!',
  'member.profile.saveButton': 'Save',
  'member.profile.changePasswordTitle': 'Change Password',
  'member.profile.password': 'Password',
  'member.profile.confirmPassword': 'Confirm Password',
  'member.profile.inputPassword': 'Please input your password!',
  'member.profile.inputConfirmPassword': 'Please confirm your password!',
  'member.profile.buttonUpdatePassword': 'Update Password',
  'member.profile.genderTitle': 'Gender',
  'member.profile.dateofBirthTitle': 'Date of Birth',
  'member.profile.phoneNumberTitle': 'Phone Number',
  'member.profile.countryTitle': 'Country',
  'member.profile.addressTitle': 'Address',
}

export default {
  locale: 'en-US',
  antdData,
  localeData,
  messages,
}
